import React, { createContext, useContext, useEffect, useState } from 'react';
import { apiService } from '../services/apiService';

const AuthContext = createContext({})

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }
  return context
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null)
  const [loading, setLoading] = useState(true)

  // Check if user is logged in on mount
  useEffect(() => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      // Verify token is valid by trying to get user data
      try {
        const userData = localStorage.getItem('auth_user')
        if (userData) {
          setUser(JSON.parse(userData))
        }
      } catch (error) {
        console.error('Error loading user:', error)
        localStorage.removeItem('auth_token')
        localStorage.removeItem('auth_user')
      }
    }
    setLoading(false)
  }, [])

  // Auth methods
  const signIn = async (email, password) => {
    try {
      const response = await apiService.login(email, password)
      // apiService handles token storage internally
      setUser(response.user)
      return { data: { user: response.user }, error: null }
    } catch (error) {
      return { data: null, error: { message: error.message || 'Login failed. Please try again.' } }
    }
  }

  const signOut = async () => {
    try {
      // Clear token from apiService
      apiService.token = null
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_user')
      setUser(null)
      return { error: null }
    } catch (error) {
      return { error: { message: 'Logout failed. Please try again.' } }
    }
  }

  const value = {
    user,
    loading,
    signIn,
    signOut,
    isAuthenticated: !!user
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
